export default "__VITE_ASSET__BdAcBwrf__"